import { createSlice } from "@reduxjs/toolkit";
import { create_email_thunk, get_emails_thunk } from './emailThunk'

const initialState = {
    data: null,
    error: null,
    loading: false
}

const createEmailCases = (builder: any) => {
    builder.addCase(create_email_thunk.pending, (state: any) => {
        state.loading = true;
        state.error = null;
    }).addCase(create_email_thunk.fulfilled, (state: any, action: any) => {
        state.loading = false;
    }).addCase(create_email_thunk.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Redux Toolkit Error'
    })
}

const getEmailCases = (builder: any) => {
    builder.addCase(get_emails_thunk.pending, (state: any) => {
        state.loading = true;
        state.error = null;
    }).addCase(get_emails_thunk.fulfilled, (state: any, action: any) => {
        state.data = action.payload.data.response;
        state.loading = false;
    }).addCase(get_emails_thunk.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Redux Toolkit Error'
    })
}


const alertSlice = createSlice({
    name: "email",
    initialState,
    reducers: {
        clearEmail: (state) => {
            state.data = null;
            state.error = null;
            state.loading = false
        },
    },
    extraReducers: (builder) => {
        createEmailCases(builder)
        getEmailCases(builder)
    }
})

export const { clearEmail } = alertSlice.actions;

export default alertSlice.reducer;
